import { createFileRoute, redirect } from '@tanstack/react-router';

import { ADMIN_LIST_SEARCH_DEFAULTS } from '@/router/listSearch';

/**
 * The bare `/institutes` half of the HS-1212 bookmark compatibility — see `institutes.$.tsx`,
 * which handles everything below it. A splat does not match an empty tail, so the section root
 * needs its own entry or the most commonly bookmarked URL of the four would 404.
 *
 * The target is a validated list route, so it must be given a search: landing there without one
 * is a type error, and at runtime it would be a list with no page.
 */
export const Route = createFileRoute('/_dashboard/institutes/')({
  beforeLoad: () => {
    throw redirect({
      to: '/institutions',
      search: ADMIN_LIST_SEARCH_DEFAULTS,
      replace: true,
    });
  },
});
